//
export default [
  {
    text: 'folio',
    value: 'folio',
    sortable: 'folio',
  },
  {
    text: 'rut',
    value: 'rut',
    format: 'rut',
    align: 'right',
    sortable: 'rut',
  },
  {
    text: 'razon social',
    value: 'razon_social',
    sortable: 'razon_social',
  },
  {
    text: 'neto',
    value: 'neto',
    format: 'currency',
    align: 'right',
    sortable: 'neto',
  },
  {
    text: 'neto total',
    value: 'neto_total',
    format: 'currency',
    align: 'right',
    sortable: 'neto_total',
  },
  {
    text: 'iva',
    value: 'iva',
    format: 'currency',
    align: 'right',
    sortable: 'iva',
  },
  {
    text: 'total',
    value: 'total',
    format: 'currency',
    align: 'right',
    sortable: 'total',
  },
  {
    text: 'tipo',
    value: 'tipo_docto',
    align: 'center',
    sortable: 'tipo_docto',
  },
  {
    text: 'estado',
    value: 'estado',
    align: 'center',
    sortable: 'estado',
  },
  {
    text: 'fecha',
    value: 'fecha',
    format: 'date',
    align: 'right',
    sortable: 'fecha',
  },
]